import { Injectable } from "@angular/core";
import { IBaseClient } from "./interface";

@Injectable({
  providedIn: 'root'
})
export class BaseClient implements IBaseClient {
  constructor() {}

  validClient: boolean = true;
  showCardDetailsSubmit: boolean = true;
  needsAgentList: boolean = false;
  allowAgentToAddTheirId: boolean = false;
  refreshCardDataAfterLoad: boolean = false;
  requireTermsModal: boolean = false;
  allowedToUseCapture: boolean = false;
  requireCxOneId:boolean = true;

  getAgent(): string | null {
    // Implementation for getting agent details
    return null;
  }
}


